/**
 * Created by shubham on 11/4/18.
 */

import {BusinessUnitListPage} from "./businessUnitList-page";

/**
 * An array of data with an associated page object used for paging
 */
export class BusinessUnitListPageData<T> {
    data = new Array<T>();
    page = new BusinessUnitListPage();
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/businessUnitManagement/businessUnitList-datatable/businessUnitList-page-data.ts